import React, { FC, useEffect, useRef, useState } from 'react';
import CheckboxAnt from 'antd/lib/checkbox';
import clsx from 'clsx';
import styles from '@pages/offers/Filters/index.module.scss';

interface ITrafficSourceOption {
    sourceOption: {
        name: string;
        id: string;
        priority: number;
        isChecked: boolean;
        categoryId: number;
    };
    onChange: (sourceId: string) => void;
}

const TrafficSourceOption: FC<ITrafficSourceOption> = ({ sourceOption, onChange }) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isEllipsis, setIsEllipsis] = useState(false);

    useEffect(() => {
        if (!textRef.current) return;

        const observer = new ResizeObserver(() => {
            if (textRef.current) {
                setIsEllipsis(textRef.current.scrollWidth > textRef.current.clientWidth);
            }
        });

        observer.observe(textRef.current);

        return () => observer.disconnect(); //eslint-disable-line
    }, [sourceOption.name]);

    return (
        <p className={`${styles.tooltip} w-full xs:w-[45%] sm:w-[30%] md:w-full`}>
            <CheckboxAnt
                id={`trafficSources${sourceOption.id}`}
                key={`trafficSources${sourceOption.id}`}
                name={`trafficSources${sourceOption.id}`}
                checked={sourceOption.isChecked}
                className="w-full epn-checkbox text-blueGray-500"
                onChange={() => onChange(sourceOption.id)}
            >
                <span className="epn-checkbox--label">
                    <span
                        className={clsx(styles.category, {
                            'text-blueGray-800': sourceOption.isChecked,
                        })}
                        ref={textRef}
                    >
                        {sourceOption.name}
                    </span>
                </span>
            </CheckboxAnt>
            {isEllipsis && <span className={styles.tooltip_text}>{sourceOption.name}</span>}
        </p>
    );
};

export default TrafficSourceOption;
